'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ActionTypes = require('MeetingsLib/redux/actions/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _UsageTracker = require('MeetingsLib/tracking/UsageTracker');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return function (next) {
    return function (action) {
      next(action);
      switch (action.type) {
        case _ActionTypes2.default.LOG_MEETING_CREATE:
          {
            // Fire google tag manager event manually on successful meeting booked
            // do not remove, marketing ops is using this event to track pqls
            try {
              var gtmMeetingBookedEvent = {
                event: 'MeetingBookedEvent',
                MeetingBookedText: 'Meeting Booked'
              };
              if (window.dataLayer && window.google_tag_manager) {
                window.dataLayer.push(gtmMeetingBookedEvent);
              }
            } catch (e) {
              window.Raven.captureBreadcrumb({
                message: 'unable to log meeting booked via datalayer'
              });
            }
            break;
          }
        case _ActionTypes2.default.SET_EVENT_DATE:
          if (action.date) {
            (0, _UsageTracker.track)('meetingsLibSetProperty', {
              property: 'event date',
              value: action.date
            });
          }
          break;
        case _ActionTypes2.default.SET_EVENT_DATE_TIME:
          if (action.dateTime) {
            (0, _UsageTracker.track)('meetingsLibSetProperty', {
              property: 'event datetime',
              value: '' + action.dateTime
            });
          }
          break;
        case _ActionTypes2.default.SET_EVENT_DURATION:
          (0, _UsageTracker.track)('meetingsLibSetProperty', {
            property: 'event duration',
            value: '' + action.duration
          });
          break;
        case _ActionTypes2.default.SET_TIMEZONE:
          (0, _UsageTracker.track)('meetingsLibSetProperty', {
            property: 'timezone',
            value: action.timezone
          });
          break;
        case _ActionTypes2.default.SET_ACTIVE_LOCALE_FINISHED:
          (0, _UsageTracker.setTrackerLang)(action.payload);
          break;
        default:
      }
    };
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/redux/middleware/TrackingMiddleware.js
// module id = 539
// module chunks = 0